import React from 'react'
import Header from '../Header/Header'
import Tracker from './Tracker'
import Footer from '../Footer/Footer'

function TrackerPage() {
  return (
    <>
    <Header/>
    <Tracker/>
    <Footer/>
    </>
  )
}

export default TrackerPage